enum status {
  PUBLIC = "PUBLIC",
  PRIVATE = "PRIVATE",
}

export default status;
